import Chartloader from "../charts/chartloader";
import {SegmentPanel} from "./segmentpanel";
import {DimensionPanel} from "./dimensionpanel";

let pageLoaded = false;

window.addEventListener("load", function () {
    pageLoaded = true;

    Segment.updateUi();
});

export class Segment {

    static #segments = this.#getFromSessionStorage();

    static setSegment(segmentData) {

        for (let i=0;i<this.#segments.length;++i) {
            if (segmentData.name === this.#segments[i].name) {
                this.#segments.splice(i, 1);
                break;
            }
        }

        this.#segments.unshift(segmentData);

        if (pageLoaded) {
            this.#updateSessionStorage();
            this.updateUi();
            Chartloader.load();
        }
    }

    static deleteSegment(segmentName) {

        // remove the segment that matches segmentName
        for (let i=0;i<this.#segments.length;++i)
            if (this.#segments[i].name === segmentName)
                this.#segments.splice(i, 1);

        if (pageLoaded) {
            this.#updateSessionStorage();
            this.updateUi();
            Chartloader.load();
        }
    }

    static getSegment(name) {
        for (let i=0;i<this.#segments.length;++i)
            if (this.#segments[i]["name"] === name)
                return this.#segments[i];

        return null;
    }

    static getSegmentQuery() {
        let query = [];
        this.#segments.forEach(segment => {
            if (segment["type"] === "is") {
                let fragment = segment.values
                    .map(value => `${segment["column"]} = '${value.replace("'", "\'")}'`)
                    .join(" or ");

                query.push(fragment);
            } else if (segment["type"] === "is not") {
                let fragment = segment.values
                    .map(value => `${segment["column"]} != '${value.replace("'", "\'")}'`)
                    .join(" and ");

                query.push(fragment);
            } else if (segment["type"] === "contains") {
                let fragment = segment.values
                    .map(value => `${segment["column"]} like '%${value.replace("'", "\'")}%'`)
                    .join(" or ");

                query.push(fragment);
            } else if (segment["type"] === "does not contain") {
                let fragment = segment.values
                    .map(value => `(not ${segment["column"]} like '%${value.replace("'", "\'")}%')`)
                    .join(" and ");

                query.push(fragment);
            } else if (segment["type"] === "starts with") {
                let fragment = segment.values
                    .map(value => `${segment["column"]} like '${value.replace("'", "\'")}%'`)
                    .join(" or ");

                query.push(fragment);
            } else if (segment["type"] === "does not start with") {
                let fragment = segment.values
                    .map(value => `(not ${segment["column"]} like '${value.replace("'", "\'")}%')`)
                    .join(" and ");

                query.push(fragment);
            }
        });

        return query
            .map(value => `(${value})`)
            .join(" and ");
    }

    static #updateSessionStorage() {
        let match = window.location.pathname.match("^/account/view/([^/]+)/")
        if (match) {
            let account = match[1];
            let key = `segment_${account}`;
            sessionStorage.setItem(key, JSON.stringify(this.#segments));
        }
    }

    static #getFromSessionStorage() {
        let match = window.location.pathname.match("^/account/view/([^/]+)/")
        if (match) {
            let account = match[1];
            let key = `segment_${account}`;
            let value = sessionStorage.getItem(key);
            if (value) {
                value = JSON.parse(value);
            } else {
                value = [];
            }
            return value;
        }

        return [];
    }

    static updateUi() {
        let maxShow = 2;
        let root = document.querySelector("#header-segments");
        if (root === null)
            return;

        root.replaceChildren();
        for (let i=0;i<Math.min(this.#segments.length, maxShow);++i) {
            let li = document.createElement("li");
            let span = document.createElement("span");

            let dimensionName = document.createElement("strong");
            dimensionName.innerText = this.#segments[i].name;
            span.appendChild(dimensionName)
            span.append(` ${this.#segments[i].type} `);
            for (let j=0;j<this.#segments[i].values.length;++j) {
                if (j > 0)
                    span.append(" or ");
                let dimensionValue = document.createElement("strong");
                dimensionValue.innerText = this.#segments[i].values[j];
                span.appendChild(dimensionValue);
            }
            let self = this;
            li.appendChild(span);

            // close icon
            let iNode = document.createElement("i");
            iNode.classList.add("fa-solid");
            iNode.classList.add("fa-xmark");
            iNode.addEventListener("click", function () {
                self.deleteSegment(self.#segments[i].name);
            });
            li.appendChild(iNode);


            // click handler that will open dimension panel
            li.addEventListener("click", function (event) {
                if (event.target.tagName === "I") {
                    // ignore click if they actually clicked on the X button, which is
                    // a font-awesome icon;
                    return;
                }
                DimensionPanel.show(self.#segments[i].name, self.#segments[i].column);
            });
            root.appendChild(li);
        }

        if (this.#segments.length > maxShow) {
            let li = document.createElement("li");
            li.append("...");
            li.addEventListener("click", function () {
                SegmentPanel.showPanel();
            });
            root.appendChild(li);
        }
    }
}

/*
Segment.setSegment({
    "name": "Browser",
    "column": "browserName",
    "type": "is",
    "values": ["Chrome", "Firefox"]
});

Segment.setSegment({
    "name": "Operating System",
    "column": "os",
    "type": "is",
    "values": ["Windows"]
});

Segment.setSegment({
    "name": "Hostname",
    "column": "hostname",
    "type": "is",
    "values": ["lytics.cloud"]
});
 */

(function(){



})();

